import { ReactComponent as App } from "../../assets/icons/ruebarue/symbol-defs.svg";
import { ReactComponent as Guide } from "../../assets/icons/guide-icons/symbol-defs.svg";

export const AppDefs = App;
export const GuideDefs = Guide;
